// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CarouselHeader_wrapper__yOMOJ","link":"CarouselHeader_link__Bff7x","multi":"CarouselHeader_multi__FBnKg"};